import SpiceAndRice from "../../modules/mosaic/spice-and-rice";

export default SpiceAndRice;
